import TablePage from '../../../../components/table_page';
import Form from './form';
import LogTable from './form/log_table.vue';

export default {
  name: 'DistrictArea',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    Form,
    LogTable,
  },

  methods: {
    clickVisible({ val, row }) {
      if (val.code === 'adjustment' && row.updateBusiness === 'Y') {
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (val.code === 'adjustment') {
        this.formName = 'Form';
        this.modalConfig.title = '调整';
        this.modalConfig.height = '400px';
        this.modalConfig.width = '500px';
        this.formConfig = {
          code: val.code,
          row,
        };
        this.openModal();
      }
    },
    // 打开日志
    logClick({ val, row }) {
      this.propsObjInData.row = row;
      this.modalConfig.title = '日志';
      this.formName = 'LogTable';
      this.openFull();
    },
  },
  created() {
    // 重写获取配置信息
    this.getConfigList('regionOldList');
  },
};
